import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import getComponentClasses from '@99designs/utils/app/getComponentClasses';
import RelativeTime from '@99designs/react-components/components/RelativeTime';
import Icon from '@99designs/react-components/components/Icon';

export default class OnsiteNotificationsListItem extends React.Component {
    thumbnail() {
        if (!this.props.notification.thumbnailUrl) {
            return null;
        }

        return (
            <img
                className="onsite-notifications__list-item__thumbnail"
                src={this.props.notification.thumbnailUrl}
            />
        );
    }

    render() {
        const notification = this.props.notification;

        const classes = classNames({
            'onsite-notifications__list-item': true,
            'onsite-notifications__list-item--read': notification.isRead,
        });

        const iconClasses = getComponentClasses('onsite-notifications__icon', [notification.icon]);

        return (
            <a
                className={classes}
                href={this.props.notification.destinationUrl}
            >
                <div className="onsite-notifications__list-item__content">
                    <div
                        className="onsite-notifications__list-item__message"
                        dangerouslySetInnerHTML={{ __html: notification.messageHtml }}
                    />
                    <div
                        className="onsite-notifications__list-item__metadata"
                    >
                        <span className={iconClasses} />
                        <span className="onsite-notifications__list-item__updated-at">
                            <RelativeTime
                                date={notification.lastActivityAt}
                                absoluteTimeFormat="long"
                            />
                        </span>
                    </div>
                </div>
                { this.thumbnail() }
            </a>
        );
    }
}

OnsiteNotificationsListItem.propTypes = {
    notification: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/components/onsite-notifications-list-item.jsx